if (!customElements.get('variant-modal-change')) {
  class VariantModalChange extends ModalDialog {
    constructor() {
      super();
      this.selectedVariantLabel = this.querySelector('#additional-variant-label');
      this.modalInfo = this.querySelector('.modal-swatch__content-info');
      this.allVariations = this.modalInfo.querySelectorAll('.swatch-additional__label');
    }

    connectedCallback() {
      super.connectedCallback();
      this.updateLabelFunction();
    }

    show(opener, blockPageScroll = true) {
      this.addEventListener(
        'transitionend',
        () => {
          this.focus();
          trapFocus(this, this.querySelector('[role="dialog"]'));
        },
        { once: true }
      );
      super.show(opener, blockPageScroll);
    }

    updateLabelFunction() {
      this.allVariations.forEach((variation) => {
        variation.addEventListener('mouseenter', () => {
          this.selectedVariantLabel.innerText = variation.dataset.variation;
        });
        variation.addEventListener('click', () => {
          this.selectedVariantLabel.innerText = variation.dataset.variation;
        });
        variation.addEventListener('focus', () => {
          this.selectedVariantLabel.innerText = variation.dataset.variation;
        });
      });
    }
  }
  customElements.define('variant-modal-change', VariantModalChange);
}
